import React from "react";
import PropTypes from "prop-types";
import { TextValidator } from "react-material-ui-form-validator";

const EMPValidatedInputField = React.forwardRef(
  (
    {
      type,
      placeholder,
      value,
      testId,
      disabled,
      readOnly,
      onChange,
      name,
      multiline,
      helperText,
      startAdornment,
      endAdornment,
      validators,
      errorMessages,
      onFocus,
    },
    ref
  ) => {
    return (
      <TextValidator
        variant="standard"
        fullWidth
        InputProps={{
          readOnly,
          disableUnderline: true,
          startAdornment,
          endAdornment,
        }}
        inputProps={{
          "data-testid": testId,
        }}
        type={type}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        ref={ref}
        name={name}
        multiline={multiline}
        helperText={helperText}
        validators={validators}
        errorMessages={errorMessages}
        onFocus={onFocus}
      ></TextValidator>
    );
  }
);

EMPValidatedInputField.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  multiline: PropTypes.bool,
  helperText: PropTypes.string,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  validators: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  ),
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  onFocus: PropTypes.func,
};

EMPValidatedInputField.defaultProps = {
  type: "text",
  placeholder: "",
  value: "",
  testId: undefined,
  disabled: false,
  readOnly: false,
  onChange: undefined,
  name: "",
  multiline: false,
  helperText: "",
  startAdornment: null,
  endAdornment: null,
  validators: [],
  errorMessages: [],
  onFocus: undefined,
};

export default EMPValidatedInputField;
